export function humanizeMinutes(totalMinutes) {
  if (totalMinutes == null || isNaN(totalMinutes)) return "—";
  const mins = Math.round(Number(totalMinutes));
  if (mins < 60) return `${mins} mins`;
  if (mins === 60) return `60 mins`;

  const days = Math.floor(mins / 1440);
  const remain = mins % 1440;
  const hours = Math.floor(remain / 60);
  const minutes = remain % 60;

  const parts = [];
  if (days) parts.push(days === 1 ? "1 day" : `${days} days`);
  if (hours) parts.push(hours === 1 ? "1 hr" : `${hours} hrs`);
  if (!days && !hours && minutes) parts.push(`${minutes} mins`);

  return parts.join(" ");
}

export function computeSLA({ lead, targetMinutes, theme }) {
  const sla = lead?.sla || null;
  const createdAt = lead?.created_at;
  const firstContactAt = sla?.first_contact_at;

  let state = {
    label: "Not Contacted",
    color: theme.palette.info.main,
    progress: null,
    oneLine: "Not contacted yet",
    detail: "No call or contact made",
  };

  if (!sla || !createdAt || !targetMinutes) return state;

  const targetHuman = humanizeMinutes(targetMinutes);

  if (firstContactAt) {
    const used = Math.round(
      (new Date(firstContactAt) - new Date(createdAt)) / 60000
    );

    const usedHuman = humanizeMinutes(used);

    if (used <= targetMinutes) {
      state.label = "Met";
      state.color = theme.palette.success.main;
    } else {
      state.label = "Breached";
      state.color = theme.palette.error.main;
    }

    state.oneLine = `${state.label} ${usedHuman} / ${targetHuman}`;
    state.detail = `${usedHuman} / ${targetHuman}`;
    state.progress = Math.min(100, Math.round((used / targetMinutes) * 100));
  } else {
    const elapsed = Math.round((Date.now() - new Date(createdAt)) / 60000);

    const left = targetMinutes - elapsed;
    const leftHuman = humanizeMinutes(Math.abs(left));

    state.progress = Math.min(100, Math.round((elapsed / targetMinutes) * 100));

    if (left >= 0) {
      state.label = "Due";
      state.color = theme.palette.warning.main;
      state.oneLine = `Due ${leftHuman}`;
      state.detail = `Target ${targetHuman}`;
    } else {
      state.label = "Overdue";
      state.color = theme.palette.error.main;
      state.oneLine = `Overdue ${leftHuman}`;
      state.detail = `Target ${targetHuman}`;
    }
  }

  return state;
}
